import { atom } from 'recoil';

// 同意チェックボックスの状態管理
const agreementCheckState = atom<boolean>({
  key: 'agreementCheckState',
  default: false,
});

export default agreementCheckState;
